// extracted by css-extract-rspack-plugin
export default {"Flash":"HiddenUnicode-module__Flash__JtHH5ZS","Button":"HiddenUnicode-module__Button__hTAJioB","Octicon":"HiddenUnicode-module__Octicon__W7xCLz2"};